import { ReactNode } from "react";
import { List, ListItem, useTheme } from "flux";

export default function FormControl({
  children,
  displayName,
  errors
}: {
  children: ReactNode;
  displayName: string;
  errors?: string[];
}) {
  const fluxTheme = useTheme();
  return (
    <fieldset style={{ marginBottom: "22px", padding: 0 }}>
      <legend>{displayName}</legend>
      {children}
      {!!errors?.length && (
        <List dense={true}>
          {errors.map((error, index) => (
            <ListItem key={index} sx={{ color: fluxTheme.palette.error.main }}>
              {error}
            </ListItem>
          ))}
        </List>
      )}
    </fieldset>
  );
}
